import { useKeycloak } from '@react-keycloak/web';
import { Spin } from 'antd';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import type { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { getConfig } from '../config/config';
import { useIsTenantAdmin } from '../hooks/useIsTenantAdmin';
import {
  APIKey,
  CreateUser,
  CreateUserGroup,
  EditUser,
  EditUserGroups,
  Forbidden,
  LoginPage,
  NonSupervisor,
  UserGroups,
  Users,
} from '../pages';
import { PrivateRoute } from './utils';
import { ComponentType } from 'react';

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface PrivateRoutes {
  path: string;
  component: ComponentType<RouteComponentProps<any>> | ComponentType<any>;
}
const AppRouter = () => {
  const { initialized } = useKeycloak();
  const isTenantAdmin = useIsTenantAdmin();

  const getAdminPrivateRoutes = (): PrivateRoutes[] => {
    let adminRoutes: PrivateRoutes[] = [];

    const userManagementRoutes: PrivateRoutes[] = [
      {
        path: '/users',
        component: Users,
      },
      {
        path: '/users/create',
        component: CreateUser,
      },
      {
        path: '/users/edit/:userId/:type?',
        component: EditUser,
      },
      {
        path: '/groups',
        component: UserGroups,
      },
      {
        path: '/groups/create',
        component: CreateUserGroup,
      },
      {
        path: '/groups/edit/:groupId/:groupName?',
        component: EditUserGroups,
      },
    ];

    const apiKeyManagementRoutes: PrivateRoutes[] = [
      {
        path: '/apikeys',
        component: APIKey,
      },
    ];

    if (getConfig().showUserManagement?.toString()?.toLowerCase() === 'true') {
      adminRoutes = userManagementRoutes;
    }

    if (
      getConfig().showApikeyManagement?.toString()?.toLowerCase() === 'true'
    ) {
      adminRoutes = [...adminRoutes, ...apiKeyManagementRoutes];
    }

    return adminRoutes;
  };
  if (!initialized) {
    return (
      <Wrapper>
        <Spin size="large" />
      </Wrapper>
    );
  }

  const versionPage = () => {
    return <div>VERSION: {import.meta.env.REACT_APP_VERSION || ''}</div>;
  };

  return (
    <Router>
      {isTenantAdmin ? (
        <Switch>
          {getAdminPrivateRoutes().map((adminRoute, index) => (
            <PrivateRoute key={index} exact {...adminRoute} />
          ))}
          <Route path="/version" component={versionPage} />
          <Route path="/forbidden" component={Forbidden} />
          <Route path="/" component={LoginPage} />
        </Switch>
      ) : (
        <Switch>
          <Route path="/version" component={versionPage} />
          <PrivateRoute exact path="/info" component={NonSupervisor} />
          <Route path="/" component={LoginPage} />
        </Switch>
      )}
    </Router>
  );
};

export default AppRouter;
